import React, { useContext, useState } from 'react';
import DataGrid from '../../../../components/DataGrid/DataGrid';
import { store as mainStore } from '../../../../store';
import { store } from './Orders';
import { localText } from '../../../../langs/fa/data-grid';
import { makeStyles } from '@material-ui/core/styles';
import { useHistory } from 'react-router-dom';
import { __ } from '../../../../utils/i18n';
import moment from 'moment-jalaali';
import Avatar from '../../../../components/User/UserAvatar';
import { Link } from 'react-router-dom';
import { formatNumber } from 'fns';
import useRules from '../../../../hooks/useRules';
import Chip from '@material-ui/core/Chip';
import { isMobile } from 'react-device-detect';

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'relative',
    width: '100%',
    height: 480,
    '& .pending': {
      background: '#ffecb3',
    },
    '& .tendering': {
      background: '#e6ee9c',
    },
    '& .getWaybill': {
      background: '#bbdefb',
    },
    '& .rejected': {
      background: '#e0e0e0',
    },
    '& .loadTime': {
      fontSize: 12,
    },
    '& .colHeader': {
      background: '#607d8b',
      color: '#fff',
    },
  },
  fleetCount: {
    fontSize: 10,
    display: 'flex',
    gap: 3,
    '& > span.red': {
      background: '#dd2c00',
      color: '#fff',
      padding: theme.spacing(0.5),
      borderRadius: 8,
    },
    '& > span.green': {
      background: '#76ff03',
      padding: theme.spacing(0.5),
      borderRadius: 8,
    },
    '& > span.white': {
      background: '#fff',
      color: '#000',
      padding: theme.spacing(0.5),
      borderRadius: 8,
    },
  },
  allOrders: {
    position: 'absolute',
    bottom: 15,
    left: 150,
  },
}));

const OrdersList = ({ order }) => {
  const classes = useStyles();
  const [rules, hasRule, isAdmin] = useRules();
  const history = useHistory();
  const {
    showMessage,
    showError,
    state: {
      Props: { itemsCountPerPage },
    },
  } = useContext(mainStore);
  const {
    state: { orders, page, loading, filters },
    dispatch,
    actions: { fetchingOrders },
  } = useContext(store);

  const [selectedOperators, setSelectedOperators] = useState(false);
  const columns = [
    {
      field: 'loadingDate',
      headerName: 'بارگیری',
      width: 80,
      renderCell: ({ value }) => moment(value.loadDate).format('jMM/jDD'),
      cellClassName: ({ value: { status } }) => status,
      headerClassName: 'colHeader',
    },
    {
      field: 'customer',
      headerName: 'صاحب‌بار',
      width: 150,
      renderCell: ({ value: { customer } }) => (
        <Avatar user={customer} fullName width={25} height={25} />
      ),
      cellClassName: ({ value: { status } }) => status,
      headerClassName: 'colHeader',
    },
    {
      field: 'origin',
      headerName: 'مبدا',
      width: 100,
      renderCell: ({ value: { origin } }) => origin.title,
      cellClassName: ({ value: { status } }) => status,
      headerClassName: 'colHeader',
    },
    {
      field: 'fleetOptions',
      headerName: 'ناوگان',
      flex: 1,
      renderCell: ({ value: { fleetOptions } }) =>
        fleetOptions.map((f) => `${f.fleet.title}(${f.title})`).join('، '),
      cellClassName: ({ value: { status } }) => status,
      headerClassName: 'colHeader',
    },
    {
      field: 'fleetCount',
      headerName: 'تعداد ناوگان',
      width: 150,
      renderCell: ({ value: { _id, fleetCount, drivers, bidders } }) => {
        if (fleetCount === 1)
          return <Link to={`/protected/admin/orders/${_id}#fleets`}>1</Link>;
        else
          return (
            <Link to={`/protected/admin/orders/${_id}#fleets`}>
              <div className={classes.fleetCount}>
                <span className="white">رزرو:{bidders?.length || 0}</span>
                <span className="red">مانده:{fleetCount - drivers.length}</span>
                <span className="green">آماده:{drivers.length}</span>
              </div>
            </Link>
          );
      },
      cellClassName: ({ value: { status } }) => status,
      headerClassName: 'colHeader',
    },
    {
      field: 'destination',
      headerName: 'مقصد',
      width: 100,
      renderCell: ({ value: { destination } }) => destination.title,
      cellClassName: ({ value: { status } }) => status,
      headerClassName: 'colHeader',
    },
    {
      field: 'netDriverRevenue',
      headerName: 'صافی راننده',
      flex: 1,
      renderCell: ({ value: order }) => {
        if (order?.proposedPrice > 0) {
          const result =
            order.proposedPrice * 1 - (order?.totalCommission || 0) * 1;
          return typeof result === 'number' ? formatNumber(result) : '-';
        }
        return '-';
      },
      cellClassName: ({ value: { status } }) => status,
      headerClassName: 'colHeader',
    },
    {
      field: 'loadingTime',
      headerName: 'زمان‌بارگیری',
      width: 100,
      renderCell: ({ value: { loadTime } }) => (loadTime ? __(loadTime) : ''),
      cellClassName: ({ value: { status } }) => `${status} loadTime`,
      headerClassName: 'colHeader',
    },
    {
      field: 'loadType',
      headerName: 'محموله',
      width: 100,
      renderCell: ({ value: { cargos } }) => cargos[0].type.title,
      cellClassName: ({ value: { status } }) => status,
      headerClassName: 'colHeader',
    },
    {
      field: 'packaging',
      headerName: 'بسته‌بندی',
      width: 100,
      renderCell: ({ value: { cargos } }) => {
        return cargos?.[0]?.packaging?.title || '-';
      },
      cellClassName: ({ value: { status } }) => status,
      headerClassName: 'colHeader',
    },
    {
      field: 'status',
      headerName: 'وضعیت',
      width: 100,
      renderCell: ({ value: { status } }) => __(status),
      cellClassName: ({ value: { status } }) => status,
      headerClassName: 'colHeader',
    },
  ];
  (hasRule('can_manage_operators') ||
    hasRule('can_select_operator_for_order')) &&
    columns.push({
      field: 'operator',
      headerName: 'ارجاعات',
      width: 120,
      renderCell: ({ value: order }) => {
        const operator = order?.operator;
        if (!operator) return '-';
        return <Avatar user={operator} onClick={handleFilterByOperator} />;
      },
      cellClassName: ({ value: { status } }) => status,
      headerClassName: 'colHeader',
    });

  const handlePageChange = async (page) => {
    dispatch({ type: 'PAGE', payload: page });
  };

  const handleSelectOrder = ({ row, field }) => {
    const { id } = row;
    const fields = ['customer', 'fleetCount', 'operator'];
    if (fields.includes(field)) return;
    history.push(`/protected/admin/orders/${id}`);
  };

  const handleFilterByOperator = async (user) => {
    setSelectedOperators(user);
    const operator = user?._id;
    const _status = Object.entries(filters.status)
      .filter((s) => s[1])
      .map((s) => s[0]);
    const filter = { ...filters, status: _status };
    const orders = await fetchingOrders(page, itemsCountPerPage, {
      ...filter,
      operator,
    });
    dispatch({ type: 'ORDERS', payload: orders });
  };

  return (
    <div className={classes.root}>
      <DataGrid
        rows={
          orders?.docs?.map((order) => ({
            id: order._id,
            loadingDate: order,
            customer: order,
            origin: order,
            fleetOptions: order,
            fleetCount: order,
            destination: order,
            netDriverRevenue: order,
            loadingTime: order,
            loadType: order,
            packaging: order,
            status: order,
            operator: order,
          })) || []
        }
        columns={columns}
        localeText={localText}
        pageSize={Number(itemsCountPerPage)}
        rowCount={orders && orders.totalDocs ? orders.totalDocs : 0}
        paginationMode="server"
        onPageChange={handlePageChange}
        loading={loading}
        disableMultipleSelection
        onCellClick={handleSelectOrder}
        density="compact"
        footerPagination={true}
        totalPages={orders?.totalPages}
        defaultPage={orders?.page}
        pageNumber={page * 1 || 1}
        // onSelectionChange={handleSelectOrder}
      />
      {!!selectedOperators && (
        <Chip
          variant="outlined"
          color="primary"
          size="small"
          onDelete={() => handleFilterByOperator()}
          label={`${selectedOperators?.firstName || ''} ${
            selectedOperators?.lastName || ''
          }`}
          className={classes.allOrders}
        />
      )}
    </div>
  );
};

export default React.memo(OrdersList);
